<div class="direct-booking-container">
  <div class="header-container">
    <div class="header">
      @if (loadingProviderProfile()) {
        <span class="skeleton-loader header-skeleton"></span>
      } @else if ([bookingStates.INITIAL, bookingStates.INITIAL_WITHOUT_TIMESLOTS, bookingStates.NEW_CLIENT_NO_TIMESLOTS, bookingStates.EXISTING_CLIENT_NO_TIMESLOTS, bookingStates.ALREADY_PROPOSED_TIME].includes(bookingState())) {
        @if (providerProfile?.hasDirectScheduling) {
          <span>Schedule your session</span>
        } @else {
          <span>Confirm your session request</span>
        }
      } @else if (bookingState() === bookingStates.NEW_CLIENT_NO_TIMESLOTS) {
        <span>Add this provider to your matched providers</span>
      } @else if(bookingState() === bookingStates.CONFIRMED) {
        <span>
          <iris-icon
            class="icon"
            [size]="irisIconSizes.LG"
            name="check"
            colorToken="$color-brand-1-base"
          ></iris-icon>
            <span>Your session is confirmed</span>
        </span>
      } @else if(bookingState() === bookingStates.REQUESTED) {
        <span>
          <iris-icon
            class="icon"
            [size]="irisIconSizes.LG"
            name="check"
            colorToken="$color-brand-1-base"
          ></iris-icon>
            <span>Session requested</span>
        </span>
      } @else if(bookingState() === bookingStates.ERROR) {
        <span class="error-message">
          <iris-icon
            [size]="irisIconSizes.SM"
            name="error"
            [color]="iconColors.DANGER"
          ></iris-icon>
          {{ errorMessage }}
        </span>
      } @else if (bookingState() === bookingStates.RESCHEDULE) {
        @if(providerProfile?.hasDirectScheduling) {
          <span>Reschedule your session</span>
        } @else {
          <span>Request to reschedule</span>
        }
      } @else if (bookingState() === bookingStates.CANCELLING) {
        <span>Cancel your session</span>
      }

      @if (!isInNativeApp) {
        <iris-icon-button
          icon="close"
          ariaLabel="Close"
          [type]="irisIconButtonTypes.TERTIARY"
          class="close-add-edit-button"
          (click)="closeModal(false)"
          [type]="irisIconButtonTypes.TERTIARY"
        >
        </iris-icon-button>
      }
    </div>

    <div class="subheader">
      @if (loadingProviderProfile()) {
        <span class="skeleton-loader subheader-skeleton"></span>
      } @else if (bookingState() === bookingStates.INITIAL || bookingState() === bookingStates.RESCHEDULE || bookingState() === bookingStates.INITIAL_WITHOUT_TIMESLOTS) {
        @if (providerProfile?.hasDirectScheduling) {
          Confirm your session details below
        } @else {
          Review the details below and confirm your session request
        }
      } @else if (bookingState() === bookingStates.NEW_CLIENT_NO_TIMESLOTS) {
        You'll be able to send {{provider.displayName}} a message after you add them to your matched providers.
      } @else if (bookingState() === bookingStates.ERROR) {
        Please choose another time.
      } @else if (bookingState() === bookingStates.CANCELLING) {
        Confirm below
      } @else if (bookingState() === bookingStates.REQUESTED) {
        We'll notify you when your session is approved.
      }
    </div>
  </div>

  <div class="card-content-container">
    <div
      class="card"
      *ngIf="provider"
    >
      <provider-photo
        class="provider-photo"
        [initials]="provider.displayName | initials"
        [photoUrl]="provider.profilePhotoUrl"
        [providerName]="provider.displayName"
      >
      </provider-photo>

      <div class="timeslot">
        @if(timeslot) {
          <span class="slot">{{timeslot.startTime | localizedDate:{ weekday: 'short', month: 'short', day: 'numeric', hour: 'numeric', minute: '2-digit' } }} ({{timezone}})</span>
        }
        @if(canChangeTime()) {
          <button
            class="change-time"
            (click)="changeTime(!changingTime())">
            Change
          </button>
        }
  
      </div>
      <div class="info">
        @if (bookingState() === bookingStates.NEW_CLIENT_NO_TIMESLOTS) {
          <div class="therapy-with">{{provider.displayName}}, {{certifications?.join(',')}}</div>
          <div>Therapy</div>
        } @else {
          <div class="therapy-with">Therapy with {{provider.displayName}}, {{certifications?.join(',')}}</div>
          <div class="section session-type">
            <div class="icon-container">
              <iris-icon
                class="icon"
                [size]="irisIconSizes.SM"
                name="videocam_outline"
                colorToken="$color-brand-1-base"
              ></iris-icon>
            </div>
            <span class="session">{{sessionType}}</span>
          </div>
          <div class="section">
            <div class="icon-container">
              @if (showCostEstimate()) {
                <iris-icon
                  class="icon"
                  [size]="irisIconSizes.SM"
                  name="dollar"
                  colorToken="$color-brand-1-base"
                ></iris-icon>
              } @else {
                <iris-icon
                  class="icon"
                  [size]="irisIconSizes.SM"
                  name="shield_health"
                  colorToken="$color-brand-1-base"
                ></iris-icon>
              }
            </div>

            <coverage-badge
              [providerId]="provider.providerId"
            ></coverage-badge>
            @if (showCostEstimate()) {
              <span class="cost-estimate">
                {{verifiedInsuranceAmount | currency}}/est cost with {{verifiedInsuranceNames$ | async}}
              </span>
            }
            <sonder-tooltip [desktopTooltipText]="tooltipText()">
              <iris-icon
                *ngIf="tooltipText()"
                displayText
                class="info-icon no-underline"
                [size]="irisIconSizes.MD"
                name="info"
                colorToken="$color-action-base"
              ></iris-icon>

              <ng-container mobileBody>
                <p class="iris-legal-responsive">
                  {{tooltipText()}}
                </p>
              </ng-container>
            </sonder-tooltip>
          </div>
        }
      </div>

      @if(changingTime() && appointmentSlots().length > 0 && !loadingTimeslots()){
        <div
          class="change-time-container"
        >
          <div class="change-time-header">Choose a session time</div>

          <appointment-carousel
            [appointmentSlots]="appointmentSlots()"
            [useBrowserTimezone]="true"
            (appointmentSlotSelectionChanged)="handleAppointmentSlotSelectionChanged($event)"
          >
          </appointment-carousel>

        </div>
      } @else if(changingTime() && loadingTimeslots()){
        <div class="change-time-container-loader">
          <div class="change-time-header">Choose a session time</div>
          <mat-spinner diameter="50"></mat-spinner>
        </div>
      }
    </div>
    @if (bookingState() === bookingStates.EXISTING_CLIENT_NO_TIMESLOTS) {
      <div class="no-availability-container">
        <span>
          <iris-icon
          class="icon"
          [size]="irisIconSizes.MD"
          name="calendar_month"
          colorToken="$color-neutral-default"
        ></iris-icon>
        </span>
        <span class="no-availability-text">
          {{provider.displayName}} is currently fully booked
        </span>
      </div>
    } @else if (bookingState() === bookingStates.ALREADY_PROPOSED_TIME) {
      <div class="no-availability-container">
        <span>
          <iris-icon
          class="icon"
          [size]="irisIconSizes.LG"
          name="access_time"
          colorToken="$color-neutral-default"
        ></iris-icon>
        </span>
        <span class="no-availability-text">
          You already have a session request waiting for {{provider.displayName}}'s approval
        </span>
      </div>
    }

    @if (bookingState() === bookingStates.CONFIRMED || bookingState() === bookingStates.REQUESTED) {
      @if ((hasMulitpleIssues$ | async)) {
        <div class="update-card-container">
          <div class="update-card-header">
            Update your insurance before your session
          </div>
          <div class="update-card-subheader">
            The following information must be updated more than 24 hours ahead of your session to avoid the risk of cancellation. 
          </div>
        </div>
      }
      @if ((!(coverageNotificationService?.hasValidInsurance$ | async) && cashPay)) {
        <div class="update-card-container">
          <div class="update-card-header">
            Add your benefits before your session
          </div>
          <div class="update-card">
            <div class="update-icon">
              <iris-icon
                class="icon"
                [size]="irisIconSizes.MD"
                name="shield_health"
                colorToken="$color-brand-1-base"
              ></iris-icon>
            </div>
            <div class="update-content">
              <div>
                Most insurance plans cover mental health services, which can reduce your costs to as little as $20-$40.
              </div>
              <div class="update-content-text">
                We'll check your benefits and give an estimated cost based on your plan details.
              </div>
            </div>
          </div>
        </div>
      }
      @if ((coverageNotificationService?.hasUnverifiedInsurance$ | async)) {
        <div class="update-card-container">
          <div class="update-card-header" *ngIf="!(hasMulitpleIssues$ | async)">
            Update your insurance before your session
          </div>
          <div class="update-card">
            <div class="update-icon">
              <iris-icon
                class="icon"
                [size]="irisIconSizes.MD"
                name="shield_health"
                colorToken="$color-brand-1-base"
              ></iris-icon>
            </div>
            <div class="update-content">
              <div class="update-card-header">
                Insurance
              </div>
              <div class="update-card-body" *ngIf="!(hasMulitpleIssues$ | async)">
                Must be updated more than <b>24 hours before your session</b> to avoid session cancellation. 
              </div>
              <div class="update-card-info">
                <b>{{ unverifiedInsuranceNames$ | async }}</b>
                <span class="update-card-info-expired">Unverified</span>
              </div>
            </div>
          </div>
        </div>
      }
      @if ((coverageNotificationService?.hasExpiredInsurance$ | async)) {
        <div class="update-card-container">
          <div class="update-card-header" *ngIf="!(hasMulitpleIssues$ | async)">
            Update your insurance before your session
          </div>
          <div class="update-card">
            <div class="update-icon">
              <iris-icon
                class="icon"
                [size]="irisIconSizes.MD"
                name="shield_health"
                colorToken="$color-brand-1-base"
              ></iris-icon>
            </div>
            <div class="update-content">
              <div class="update-card-header">
                Insurance
              </div>
              <div class="update-card-body" *ngIf="!(hasMulitpleIssues$ | async)">
                Must be updated more than <b>24 hours before your session</b> to avoid session cancellation. 
              </div>
              <div class="update-card-info">
                <b>{{ expiredInsuranceNames$ | async }}</b>
                <span class="update-card-info-expired">No longer valid</span>
              </div>
            </div>
          </div>
        </div>
      }
      
      @if ((expiredCreditCard$ | async)) {
        <div class="update-card-container">
          <div class="update-card-header" *ngIf="!(hasMulitpleIssues$ | async)">
            Update your payment method before your session
          </div>
      
          <div class="update-card">
            <div class="update-icon">
              <iris-icon
                class="icon"
                [size]="irisIconSizes.MD"
                name="credit_card"
                colorToken="$color-brand-1-base"
              ></iris-icon>
            </div>
            <div class="update-content">
              <div class="update-card-header">
                Payment
              </div>
              <div class="update-card-body" *ngIf="!(hasMulitpleIssues$ | async)">
                must be updated more than <b>24 hours before your session</b>
                to avoid session cancellation.
              </div>
              <div class="update-card-info">
                <img src="assets/card-logos/{{(expiredCreditCard$ | async)?.brand}}.svg" alt="visa" class="update-card-info-brand">
                  •••• •••• •••• {{(expiredCreditCard$ | async)?.last4}}
                <span class="update-card-info-expired">Expired</span>
              </div>
            </div>
            
          </div>
        </div>
      }
    }
  </div>

  <div class="action-buttons">
    @if ([bookingStates.INITIAL, bookingStates.INITIAL_WITHOUT_TIMESLOTS, bookingStates.NEW_CLIENT_NO_TIMESLOTS, bookingStates.ERROR].includes(bookingState())) {
      <button
        class="cancel-button iris-button iris-button--secondary"
        (click)="closeModal(false)"
      >
        Cancel
      </button>
      <button
        class="confirm-button iris-button iris-button--primary"
        (click)="confirmSession()"
        [disabled]="submittingSession"
      >
        {{bookingState() === bookingStates.NEW_CLIENT_NO_TIMESLOTS ? 'Add to matches' : 'Confirm session'}}
        <mat-spinner diameter="20" class="confirm-button-spinner" *ngIf="submittingSession"></mat-spinner>
      </button>
    }
    @else if (bookingState() === bookingStates.RESCHEDULE) {
      <button
        class="cancel-button iris-button iris-button--secondary"
        (click)="closeModal(false)"
      >
        Cancel
      </button>
      <button
        class="confirm-button iris-button iris-button--primary"
        (click)="rescheduleSession()"
        [disabled]="submittingSession"
      >
        Confirm session
        <mat-spinner diameter="20" class="confirm-button-spinner" *ngIf="submittingSession"></mat-spinner>
      </button>
    }
    @else if (bookingState() === bookingStates.CANCELLING) {
      @if (canRescheduleInCancelState()) {
        <button
          class="cancel-button iris-button iris-button--secondary"
          (click)="rescheduleCanceledSession()"
        >
          Reschedule session
        </button>
      }

      <button
        class="cancel-session-button iris-button iris-button--danger"
        (click)="cancelSession()"
        [disabled]="submittingSession"
      >
        Cancel session
        <mat-spinner diameter="20" class="cancelled-button-spinner" *ngIf="submittingSession"></mat-spinner>
      </button>
    } @else if(bookingState() === bookingStates.EXISTING_CLIENT_NO_TIMESLOTS || bookingState() === bookingStates.ALREADY_PROPOSED_TIME) {
      <button
        class="cancel-button iris-button iris-button--secondary"
        (click)="closeModal(false)"
      >
        Close
      </button>
    }
    @else if (expiredCreditCard$ | async) {
      <button
        class="cancel-button iris-button iris-button--secondary"
        (click)="closeModal(true)"
      >
        I'll do this before my session
      </button>
      <button
        class="confirm-button iris-button iris-button--primary"
        (click)="updateCreditCard()"
      >
        Update details now
      </button>
    }
    @else if ((coverageNotificationService?.hasUnverifiedInsurance$ | async) 
              || (coverageNotificationService?.hasExpiredInsurance$ | async)) {
      <button
        class="cancel-button iris-button iris-button--secondary"
        (click)="closeModal(true)"
      >
        I'll do this before my session
      </button>
      <button
        class="confirm-button iris-button iris-button--primary"
        (click)="updateInsurance()"
      >
        Update details now
      </button>
    }
    @else if (cashPay && !(coverageNotificationService?.hasValidInsurance$ | async)) {
      <button
        class="cancel-button iris-button iris-button--secondary"
        (click)="closeModal(true)"
      >
        Continue with cash pay
      </button>
      <button
        class="confirm-button iris-button iris-button--primary"
        (click)="updateInsurance()"
      >
        Add insurance
      </button>
    }
    @else {
      <button
        class="cancel-button iris-button iris-button--secondary"
        (click)="closeModal(true)"
      >
        Close
      </button>
    }
  </div>
</div>
